import React, { FC } from 'react'
import SpTelInput from 'components/TelInput/SpTelInput'
import styles from '../style.module.css'

type Props = {
  initialPhone: string
  errorMessage: string | null
  onSubmit: (phone: string) => void
  onClose: () => void
}

const DeliveryReportPhoneInput: FC<Props> = ({ initialPhone, errorMessage, onSubmit, onClose }) => {
  return (
    <>
      {errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
      <SpTelInput
        title="電話番号を入力"
        isOpen={true}
        isShowPhoneNumberPrefix={true}
        initialValue={initialPhone}
        onClickEnter={onSubmit}
        onClickClose={onClose}
      />
    </>
  )
}

export default DeliveryReportPhoneInput
